import Form from 'components/Form'
import Password from 'components/Fields/Password'
import Checkbox from 'components/Fields/Checkbox'

import validators from 'utils/validators'
import useTranslate from '../../hooks/useTranslate'

const validationSchema = validators.object({
  email: validators.email(),
  password: validators.requiredString()
})

const emailField = {
  name: 'email',
  label: 'INPUT_EMAIL',
  autoComplete: 'email',
  type: 'email',
  hidePlaceholder: true,
  required: true
}
const passwordField = {
  name: 'password',
  label: 'INPUT_PASSWORD',
  autoComplete: 'current-password',
  type: 'password',
  required: true,
  component: Password
}
const keepMeLoggedInField = {
  name: 'keepMeLoggedIn',
  label: 'KEEP_ME_LOGGED_IN',
  required: false,
  hideLabel: true,
  component: Checkbox,
}

const fieldSchema = [
  emailField,
  passwordField,
  keepMeLoggedInField
]

const LoginForm = (props) => {
  const { onSubmit, parseError, initialValues } = props
  const translate = useTranslate()

  const handleSubmit = React.useCallback((values) => {
    if (onSubmit) {
      return onSubmit(values)
    }
  }, [])

  const formProps = {
    onSubmit: handleSubmit,
    buttonLabel: translate('BUTTON_LABEL_SUBMIT'),
    fieldSchema,
    validationSchema,
    parseError,
    initialValues
  }
  return (
    <Form {...formProps} />
  )
}

export default LoginForm
